<template>
<grid-layout
    :layout.sync="value"
    :col-num="24"
    :row-height="30"
    :is-draggable="true"
    :is-resizable="true"
    :margin="[10, 10]"
    :use-css-transforms="true"
    @layout-updated="onLayoutUpdated">
    <grid-item v-for="l in value"
        drag-allow-from=".handle"
        :x="l.x"
        :y="l.y"
        :h="l.h"
        :w="l.w"
        :i="l.i" :key="l.i"
        @moved="overlayData[l.i].mask = false"
        @resize="overlayData[l.i].mask = true"
        @resized="overlayData[l.i].mask = false">
        <div class="maximized"
             @mouseover="overlayData[l.i].showHandle = true"
             @mouseleave="overlayData[l.i].showHandle = false">
            <b-card class="maximized" no-body>
                <iframe :src='`${domain}${l.i}`' style="width: 100%; height: 100%; border: none" frameBorder="0">
                </iframe>
            </b-card>
            <div v-if="overlayData[l.i].mask" class="mask"></div>
            <div v-if="overlayData[l.i].showHandle || overlayData[l.i].mask" class="handle" @mousedown="overlayData[l.i].mask = true" @mouseup="overlayData[l.i].mask = false">
                <a :href="`/embeddable_widgets/${l.i}`"><fa-icon class="ctrl-icon" icon="pen"></fa-icon></a>
                <fa-icon class="ctrl-icon" icon="arrows-alt"></fa-icon>
                <fa-icon class="ctrl-icon" icon="times" @click.prevent="removeItem(l.i)"></fa-icon>
            </div>
        </div>
    </grid-item>
</grid-layout>
</template>

<script>
  import VueGridLayout from 'vue-grid-layout';
  import { request } from '../api'

  export default {
    components: {...VueGridLayout},
    props: {
      id: Number,
      value: {
        type: Array,
        default: () => ([])
      },
      domain: {
        type: String,
      }
    },
    data() {
        return {
            overlayData: []
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(nv) {
                this.overlayData = Object.fromEntries(nv.map(e => ([e.i, {
                    mask: false,
                    showHandle: false
                }])))
            }
        }
    },
    methods: {
      onLayoutUpdated(layout) {
          this.$emit('input', layout)
      },
      removeItem(id) {
          const newLayout = this.value.filter(x => x.i !== id)
          this.value = newLayout
          this.onLayoutUpdated(newLayout)
      }
    }
  }
</script>

<style scoped>
    .maximized {
        width: 100%;
        height: 100%;
    }

    .handle {
        position: absolute;
        top: 0;
        right: 0;
        height: 30px;
        background: rgba(0,0,0,0.2);
        padding: 2px 5px;
        border-radius: 0 0 0.25rem 0.25rem;
        margin-right: 10px;
    }

    .mask {
        position:absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
    }

    .ctrl-icon {
        height:100%;
        width: 15px;
        cursor:pointer;
    }
</style>
